export default __webpack_public_path__ + "static/media/value.c4937662.png";